import { render, staticRenderFns } from "./promotedProducts.vue?vue&type=template&id=4e7807e2&"
import script from "./promotedProducts.vue?vue&type=script&lang=js&"
export * from "./promotedProducts.vue?vue&type=script&lang=js&"
import style0 from "./promotedProducts.vue?vue&type=style&index=0&id=4e7807e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports